// @flow

import styled from 'styled-components';
import { HighlightBox } from '../../../../atoms';

export const TicketLineSeparator = styled(HighlightBox)`
  margin: 0 1.2em;
  border-style: solid none none none;
`;
